import { Box, Text } from '@razorpay/blade/components';
import React from 'react';
import { EmployeeLoansSettingsSectionListItemProps } from './types';

export const EmployeeLoansSettingsSectionListItem = ({
  label,
  value,
  shouldHaveBorderBottom = true,
}: EmployeeLoansSettingsSectionListItemProps) => {
  return (
    <Box
      flexDirection="row"
      display="flex"
      borderBottomColor={shouldHaveBorderBottom ? 'surface.border.gray.subtle' : undefined}
      borderBottomWidth={shouldHaveBorderBottom ? 'thin' : undefined}>
      <Box width="30%" padding="spacing.4" textAlign="right">
        <Text color="surface.text.gray.muted">{label}</Text>
      </Box>
      <Box
        width="70%"
        padding="spacing.4"
        display="flex"
        justifyContent="space-between"
        alignItems="center">
        <Text color="surface.text.gray.normal">{value}</Text>
      </Box>
    </Box>
  );
};
